function qas_Reducer(state = [], action) {
    switch (action.type) {
        case 'QAS/SET':
            return action.qas;
        case 'QAS/CLEAR':
            return null;
        default:
            return state;
    }
}

export default qas_Reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/qas.js